import { render, staticRenderFns } from "./Endocrinology.vue?vue&type=template&id=3166c408&scoped=true"
import script from "./Endocrinology.vue?vue&type=script&lang=js"
export * from "./Endocrinology.vue?vue&type=script&lang=js"
import style0 from "./Endocrinology.vue?vue&type=style&index=0&id=3166c408&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3166c408",
  null
  
)

export default component.exports